/** @graphql cc **/
import gql from 'graphql-tag';

export const QuestionListQuery = gql`
	query QuestionListQuery(
		$cloudId: ID!
		$cql: String!
		$limit: Int
		$after: String
		$answerContentType: String
	) {
		search: confluence_search(cloudId: $cloudId, cql: $cql, first: $limit, after: $after) {
			nodes {
				content {
					id
					title
					labels {
						nodes {
							name
						}
					}
					space {
						name
						alias
						key
					}
					properties {
						nodes {
							key
							value
						}
					}
					history {
						createdDate
						createdBy {
							displayName
						}
					}
					children(type: $answerContentType) {
						nodes {
							id
						}
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;
